import { createSlice } from "@reduxjs/toolkit";
import { getPropertiesEntry } from "../requests";
import SaveWebView from "../requests/saveWebViev";
import { FetchMultiUrlData } from "../requests/multiUrl";

const initialState = {
  valueLink: ["", ""],
  valueStoreAppleGoogle: ["", "", "", ""],
  valueVCard: ["", "", [""], [""], "", "", "", [""], "", "#ffffff", false, ""],
  valueEmail: ["", "", "", ""],
  valueWhatsApp: ["", "", ""],
  saveWebViewValue: null,
  valueCrypto: ["", "", "", ""],
  valueText: [""],
  valueLinkList: {
    colors: ["#2F6BFD", "#0E379A", "#FFFFFF"],
    qrTitle: "",
    title: "",
    description: "",
    logo: "",
    links: [],
    socials: [],
    isLogoRound: true,
  },
  valueMultiUrl: ["", 0],
  valueMap: ["", "", "", ""],
  valueNameQr: "",
  valuePhone: [""],
  valueSms: ["", ""],
  firstPageSearchValue: "",
};

const saveValue = createSlice({
  name: "saveValue",
  initialState,
  reducers: {
    resetSaveValue() {
      return initialState;
    },
    saveValueLink(state, { payload }) {
      state.valueLink = payload;
    },
    saveStoreAppleGoogle(state, { payload }) {
      state.valueStoreAppleGoogle = payload;
    },
    saveVCard(state, { payload }) {
      state.valueVCard = payload;
    },
    saveEmail(state, { payload }) {
      state.valueEmail = payload;
    },
    saveWhatsApp(state, { payload }) {
      state.valueWhatsApp = payload;
    },
    saveCrypto(state, { payload }) {
      state.valueCrypto = payload;
    },
    saveValueText(state, { payload }) {
      state.valueText = payload;
    },
    saveValueLinkList(state, { payload }) {
      state.valueLinkList = payload;
    },
    saveValueMultiUrl(state, { payload }) {
      state.valueMultiUrl = payload;
    },
    saveValueMap(state, { payload }) {
      state.valueMap = payload;
    },
    saveValueNameQr(state, { payload }) {
      state.valueNameQr = payload;
    },
    saveValuePhone(state, { payload }) {
      state.valuePhone = payload;
    },
    saveValueSms(state, { payload }) {
      state.valueSms = payload;
    },
    setFirstPageSearchValue(state, { payload }) {
      state.firstPageSearchValue = payload;
    },
  },
  extraReducers: {
    [SaveWebView.fulfilled]: (state, { payload }) => {
      state.saveWebViewValue = payload;
    },
    [FetchMultiUrlData.fulfilled]: (state, { payload }) => {
      state.valueMultiUrl[1] = payload.type;
    },
    [getPropertiesEntry.fulfilled]: (state, { payload }) => {
      state.valueNameQr = payload.qrTitle;
    },
  },
});
export const {
  saveValueLink,
  saveStoreAppleGoogle,
  saveVCard,
  saveEmail,
  saveWhatsApp,
  saveCrypto,
  resetSaveValue,
  saveValueText,
  saveValueLinkList,
  saveValueMultiUrl,
  saveValueMap,
  saveValueNameQr,
  saveValuePhone,
  saveValueSms,
  setFirstPageSearchValue,
} = saveValue.actions;
export default saveValue.reducer;
